import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import tripleDot from '../../media/tripleDot.svg';
import profileLogo from '../../media/user.png';
import LogContext from '../../context/LogContext';
import { accountScroll } from '../../utils/accountScroll';
const backendUrl = process.env.REACT_APP_BACKEND_URL;

const GOOGLE_API_KEY = "AIzaSyCfhqoLXcnvcNZ8q8oJW_kA4uC--bhS_Co";

export default function Address() {
  const navigate = useNavigate();
  const myContext = useContext(LogContext);
  const [addNew, setAddNew] = useState(false);
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [pincode, setPincode] = useState('');
  const [locality, setLocality] = useState('');
  const [areaNstreet, setAreaNstreet] = useState('');
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [landmark, setLandmark] = useState('');
  const [alternatePhone, setAlternatePhone] = useState('');
  const [addressType, setAddressType] = useState('');
  const [email, setEmail] = useState('');
  const [canSave, setCanSave] = useState(true);
  const [savedAddresses, setSavedAddresses] = useState([]);
  const [currentLocationActive, setCurrentLocationActive] = useState(false);

  const handelRadio = (e) => {
    setAddressType(e.target.value);
  };

  const getUserAddresses = async () => {
    try {
      const response = await fetch(`${backendUrl}/getUserAddresses`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email: myContext.user.email }),
      });
      if (response.ok) {
        const data = await response.json();
        setSavedAddresses(data.data);
        console.log('Data fetched successfully');
      } else {
        console.log('Data fetch unsuccessful');
      }
    } catch (error) {
      console.error('Error fetching user addresses:', error);
    }
  };

  const handelSave = async () => {
    const address = { name, phone, pincode, locality, areaNstreet, city, state, landmark, alternatePhone, addressType };
    try {
      const response = await fetch(`${backendUrl}8001/saveAddress`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, address }),
      });
      if (response.ok) {
        const data = await response.json();
        console.log('Saved successfully');
        window.location.reload();
        setAddNew(false);
      } else {
        console.error('Failed to save');
      }
    } catch (error) {
      console.error('An error occurred:', error);
    }
  };

  const handelDelete = async (e) => {
    const indexString = e.target.id;
    const id = indexString[indexString.length - 1];
    try {
      const response = await fetch(`${backendUrl}/deleteSavedAddress`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email: myContext.user.email, index: id }),
      });
      if (response.ok) {
        console.log('Deleted successfully');
        window.location.reload();
      } else {
        console.log('Error deleting address');
      }
    } catch (error) {
      console.error('An error occurred while deleting address:', error);
    }
  };

  const handelLogout = async () => {
    try {
      const response = await axios.get(`${backendUrl}/logout`, {
        withCredentials: true, // Include cookies in the request
      });
      if (response.status === 200) {
        navigate('/', { replace: true });
        setTimeout(() => {
          window.location.reload();
        }, 0);
        console.log('Logout successfully');
      } else {
        console.error('Logout failed');
      }
    } catch (error) {
      console.error('An error occurred during logout:', error);
    }
  };

  const getCurrentLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;
          try {
            const response = await axios.get(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${GOOGLE_API_KEY}`);
            console.log(response)
            if (response.data && response.data.results && response.data.results.length > 0) {
              const addressDetails = response.data.results[0];
             
              console.log(addressDetails)
              setAreaNstreet(addressDetails.formatted_address)
              setLocality(getAddressComponent(addressDetails, 'sublocality_level_1'));
              setCity(getAddressComponent(addressDetails, 'locality'));
              setState(getAddressComponent(addressDetails,"administrative_area_level_1"))
              setPincode(getAddressComponent(addressDetails, 'postal_code'));
            }
          } catch (error) {
            console.error('Error fetching current location:', error);
          }
        },
        (error) => {
          console.error('Error getting current location:', error);
        }
      );
    } else {
      console.error('Geolocation is not supported by this browser.');
    }
  };

  const getAddressComponent = (addressDetails, type) => {
    const component = addressDetails.address_components.find((component) => component.types.includes(type));
    return component ? component.long_name : '';
  };

  const handleScroll =()=>{
    if(window.innerWidth<=576){
      accountScroll('account-scroll');
    }
  }
  useEffect(() => {
    if (myContext.user.email) {
      getUserAddresses(myContext.user.email);
      setEmail(myContext.user.email);
    }
  }, [myContext.user.email]);

  useEffect(() => {
    if (name && phone && pincode && locality && areaNstreet && city && state && addressType) {
      setCanSave(false);
    }
  });
  useEffect(() => {
  const timer = setTimeout(() => {
    if (window.innerWidth <= 576) {
      accountScroll('account-scroll');
    }
  }, 100); // You might increase this to 300ms if DOM isn't fully ready

  return () => clearTimeout(timer); // cleanup in case the component unmounts quickly
}, []);


  return (
    <div className='profile' style={{marginTop:''}}>
      <div className='row'>
        <div className='col-sm-4 col-xs-12'>
          <div style={{ display: 'flex' }} className='hello'>
            <img src={profileLogo} alt='' />
            {/* <p className='hello-text'>Hello!</p> */}
            <p className='name-text'>{myContext.user.firstName+" "+myContext.user.lastName}</p>
          </div>
          <div className='profile-list'>
            <p className='list-item' style={{ cursor: 'pointer' }} onClick={() => {navigate('/account/orders'); handleScroll()}}>
              <i className='fa-solid fa-bag-shopping'></i> <span className='head'>Orders</span> <hr />
            </p>
            <ul className='account-settings'>
              <li className='list-item'>
                <i className='fa-solid fa-user'></i><span className='head'> Account Settings</span>
              </li>
              <li className='list-item' style={{ cursor: 'pointer' }} onClick={() => {navigate('/account/personal-info'); handleScroll()}}>
                Personal Information
              </li>
              <li className='list-item' style={{ cursor: 'pointer' }} onClick={() => {navigate('/account/addresses'); handleScroll()}}>
                Manage Addresses
              </li>
            </ul>
            <ul>
              <li className='list-item'>
                <i className='fa-solid fa-briefcase'></i> <span className='head'>My Stuff</span>
              </li>
              <li className='list-item' style={{ cursor: 'pointer' }} onClick={() => {navigate('/account/wishlist'); handleScroll()}}>
                My Wishlist<hr />
              </li>
            </ul>
            <div id='account-scroll'>
              <p className='list-item' style={{ cursor: 'pointer' }} onClick={handelLogout}>
                <i className='fa-solid fa-right-from-bracket'></i> Logout
              </p>
            </div>
          </div>
        </div>
        <div className='col-sm-8 col-xs-12' style={{background:'white'}}>
          <div className='address'>
            <p className='head'>Manage Addresses</p>
            <div className='addnew-address'>
              <i className='fa-solid fa-plus' style={{ cursor: 'pointer' }} onClick={() => setAddNew(true)}></i> ADD A NEW ADDRESS
              {addNew && (
                <>
                  <div>
                    <div className='current-location'>
                      <button className='btn-location' onClick={getCurrentLocation}>
                        <i className='fa-solid fa-location-crosshairs'></i> Use my current location
                      </button>
                    </div>
                  </div>
                  <div className='address-form'>
                    <input className='inp-small' type='text' name='name' placeholder='Name' onChange={(e) => setName(e.target.value)} />
                    <input className='inp-small' type='text' name='phone' placeholder='10-digit mobile number' onChange={(e) => setPhone(e.target.value)} />
                    <br />
                    <input className='inp-small' type='text' name='pincode' placeholder='Pincode' value={pincode} onChange={(e) => setPincode(e.target.value)} />
                    <input className='inp-small' type='text' name='locality' placeholder='Locality' value={locality} onChange={(e) => setLocality(e.target.value)} />
                    <br />
                    <textarea className='inp-big' type='text' name='address' placeholder='Address (Area and Street)' value={areaNstreet} onChange={(e) => setAreaNstreet(e.target.value)} />
                    <br />
                    <input className='inp-small' type='text' name='city' placeholder='City/District/Town' value={city} onChange={(e) => setCity(e.target.value)} />
                    <input className='inp-small' type='text' name='state' placeholder='State'value={state} onChange={(e) => setState(e.target.value)} />
                    <br />
                    <input className='inp-small' type='text' name='landmark' placeholder='Landmark (Optional)' onChange={(e) => setLandmark(e.target.value)} />
                    <input className='inp-small' type='text' name='alternate-phone' placeholder='Alternate Phone (Optional)' onChange={(e) => setAlternatePhone(e.target.value)} />
                    <p className='address-type'>Address Type</p>
                    <input className='radioo' type='radio' name='addressType' id='home' value='Home' checked={addressType === 'Home'} onChange={handelRadio} />
                    <label className='radio-label' htmlFor='home'>Home</label>
                    <input className='radioo' type='radio' name='addressType' id='work' value='Work' checked={addressType === 'Work'} onChange={handelRadio} />
                    <label className='radio-label' htmlFor='work'>Work</label>
                    <br />
                    <button className='save-btn' onClick={handelSave} disabled={canSave}>Save</button>
                    <button className='cancel-btn' onClick={() => setAddNew(false)}>Cancel</button>
                  </div>
                </>
              )}
            </div>
            <div className='addresses'>
              {savedAddresses &&
                savedAddresses.map((address, index) => (
                  <div key={index} className='item'>
                    <div style={{ display: 'flex' }}>
                      <button className='btn-add-type'>{address.addressType}</button>
                    </div>
                    <p className='name'>{address.name} <span className='phone'>{address.phone}</span>
                      <span className='delete-address'><i className='fa-solid fa-trash pull-right' id={`addressIndex-${index}`} onClick={handelDelete}></i></span>
                    </p>
                    <p className='address'>{address.areaNstreet}<span className='pincode'></span></p>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
